import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Icon from '../Icon';
import Spacer from '../Spacer';
import UnlockIcon from '../../svg/icons/Resy_Unlock_Icon.svg';
import { getTranslation } from '../../providers/TranslationProvider';

import './NomaBanner.scss';

export const NOMA_BANNER_HEADLINE = 'Platinum Nights by Resy';
export const NOMA_BANNER_TAGLINE = 'To unlock access to available reservations, login and add your eligible American Express card to your Resy profile.';
export const NOMA_CARD_OFFER = 'Not a Card Member? Explore Amex Card Offers';
export const NOMA_BRAND_ICON = 'https://s3.amazonaws.com/resy.com/images/announcements/brand_icon.png';
export const NOMA_LEARN_MORE_TEXT = 'Explore Amex Card Offers';
export const NOMA_LEARN_MORE_LINK = 'https://www.americanexpress.com/en-us/credit-cards/offers/resy/?extlink=resy-gate&eep=46100';

const NOMA_BANNER_ADD_ELIGIBLE_CARD = 'noma_banner_add_eligible_card';

// Custom banner component for Noma gating that is displayed for users that not logged in or not eligible https://resy.atlassian.net/browse/CON-16248
const NomaBanner = ({ isUserLoggedIn, onLogin, onAddCard }) => (
  <div className="NomaBanner" data-test-id="noma-banner">
    <div className="NomaBanner__content">
      <div className="NomaBanner__Logo">
        <Icon
          component={UnlockIcon}
          iconClass="GatingMessage__Lock-anim"
          ariaLabel={getTranslation({ translationKey: 'unlocking_animation', fallback: 'Unlocking animation' })}
          height="120px"
          width="120px"
        />
      </div>
      <Spacer width="15" />
      <div className="NomaBanner__verbiage">
        <div className="NomaBanner__headline">
          {getTranslation({ translationKey: 'noma_banner_headline', fallback: NOMA_BANNER_HEADLINE })}
        </div>

        <div className="NomaBanner__tagline">
          {getTranslation({ translationKey: 'noma_banner_tagline', fallback: NOMA_BANNER_TAGLINE })}
        </div>
      </div>
    </div>
    <div className="NomaBanner__ctas">
      {!isUserLoggedIn ? (
        <Button
          className="NomaBanner__login-button"
          variant="primary"
          onClick={() => onLogin()}
          aria-label={
              getTranslation({
                translationKey: 'login',
                fallback: 'Login',
              })
            }
          fullWidth
        >
          {getTranslation({
            translationKey: 'login',
            fallback: 'Login',
          })}
        </Button>
      ) : (
        <Button
          className="NomaBanner__login-button"
          variant="primary"
          onClick={onAddCard}
          data-test-id="noma-login-button-banner"
          aria-label={
              getTranslation({
                translationKey: NOMA_BANNER_ADD_ELIGIBLE_CARD,
                fallback: 'Add Your Eligible Card',
              })
            }
          fullWidth
        >
          {getTranslation({
            translationKey: NOMA_BANNER_ADD_ELIGIBLE_CARD,
            fallback: 'Add Your Eligible Card',
          })}
        </Button>
      )}
    </div>
  </div>
);

NomaBanner.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  onAddCard: PropTypes.func.isRequired,
};

NomaBanner.displayName = 'NomaBanner';

export default NomaBanner;
